import { TranslateService } from '@ngx-translate/core'
import { lastValueFrom } from 'rxjs'
import * as sharedTranslations from 'libs/shared/assets/i18n/en.json'
import * as sharedTranslationsUS from 'libs/shared/assets/i18n/en-us.json'

export function appLanguageInitializerFactory(translate: TranslateService, defaultLanguage: any, enUS: any) {
  return async () => {
    const usLangCodes = ['en', 'en-US', 'en-CA']
    // Set language to English to then be overridden by other languages as needed,
    // This is to avoid the moment where the app will show the translation keys
    translate.setTranslation('en', defaultLanguage)
    // Merge shared translations
    translate.setTranslation('en', sharedTranslations, true)
    // Get culture language code name from the browser i.e. en-AU
    const localeLang = translate.getBrowserCultureLang() as string
    // Merge en-US translations if US lang code
    if (usLangCodes.includes(localeLang)) {
      translate.setTranslation('en', enUS, true)
      translate.setTranslation('en', sharedTranslationsUS, true)
    }

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en')

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    return await lastValueFrom(translate.use('en'))
  }
}
